/* eslint-disable */
import { SVGProps } from "react";
const SvgBattery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19.606}
    height={12.258}
    fill="currentColor"
    viewBox="0 0 19.606 12.258"
    {...props}
  >
    <path
      d="M18.176 2.452h-.2v-.2A2.25 2.25 0 0 0 15.731 0H2.247A2.25 2.25 0 0 0 0 2.247v7.764a2.25 2.25 0 0 0 2.247 2.247h13.484a2.25 2.25 0 0 0 2.247-2.247v-.2h.2a1.432 1.432 0 0 0 1.43-1.43V3.882a1.432 1.432 0 0 0-1.432-1.43Zm-6.8 3.081-2.86 4.493a.407.407 0 0 1-.344.189.423.423 0 0 1-.138-.024.41.41 0 0 1-.267-.436l.351-2.81H6.943a.409.409 0 0 1-.332-.646l2.923-4.086a.409.409 0 0 1 .736.3L9.878 4.9h1.151a.408.408 0 0 1 .344.628Z"
    />
  </svg>
);

export default SvgBattery;
